export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5631.ee76f575.jpg";